import { render, staticRenderFns } from "./DetailPromotion.vue?vue&type=template&id=2f88381a&"
import script from "./DetailPromotion.vue?vue&type=script&lang=js&"
export * from "./DetailPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports